import { getLabel } from '../../../../validators'
import { RowAdding } from './RowAdding'
import BlockDictionaryRow from './BlockDictionaryRow'
import { Dispatch, SetStateAction } from 'react'
import { DescriptionBtnWithPopup } from '../../../buttons/PromptBtn/DescriptionBtnWithPopup'
import { isAllNumeric } from '../lib/helpers'

interface BlockDictionaryTableProps {
    dataPath: string
    data: Record<string, any>
    dataSchema: Record<string, any>
    name: string
    path: string[]
    dictKeys: string[]
    setDictKeys: Dispatch<SetStateAction<string[]>>
    isAdding: boolean
    setIsAdding: Dispatch<SetStateAction<boolean>>
    actionAddDictValue?: (item: Record<string, string>) => void
}

export const BlockDictionaryTable = (props: BlockDictionaryTableProps) => {
    const {
        dataPath,
        data,
        dataSchema,
        name,
        path,
        dictKeys,
        setDictKeys,
        isAdding,
        setIsAdding,
        actionAddDictValue,
    } = props

    const sortedDictKeys = isAllNumeric(dictKeys)
        ? dictKeys.sort((a, b) => parseFloat(a) - parseFloat(b))
        : dictKeys
    const componentSchema = dataSchema?.children
    const keyNames = Object.keys(componentSchema)

    const onCancelAddHandle = () => {
        setIsAdding(false)
    }

    return (
        <table className="m-0 table app-table table-hover p-relative w-100">
            <thead>
                <tr
                    className="border-bottom bg-body py-4"
                    style={{
                        color: '#8dabc4',
                        fontSize: '.7rem',
                        textTransform: 'uppercase',
                        position: 'sticky',
                        top: 0,
                    }}
                >
                    <td>#</td>
                    {keyNames.map((keyName: string) => (
                        <td key={keyName}>
                            {getLabel(
                                componentSchema?.[keyName]?.name || keyName
                            )}
                            {(keyName === 'key' ||
                                componentSchema[keyName]?.is_required) &&
                                '*'}
                            {componentSchema[keyName]?.description && (
                                <DescriptionBtnWithPopup
                                    type="small"
                                    header={getLabel(
                                        componentSchema?.[keyName]?.name || keyName
                                    )}
                                    description={
                                        componentSchema[keyName]?.description
                                    }
                                    className="mt-1"
                                />
                            )}
                        </td>
                    ))}
                    <td>Actions</td>
                </tr>
                <RowAdding
                    setDictKeys={setDictKeys}
                    schema={dataSchema.children}
                    path={path}
                    data={data}
                    isAdding={isAdding}
                    onCancelAdd={onCancelAddHandle}
                    actionAddDictValue={actionAddDictValue}
                />
            </thead>
            <tbody>
                {sortedDictKeys.map((el: string, index: number) => (
                    <BlockDictionaryRow
                        key={el}
                        dataPath={dataPath}
                        position={index + 1}
                        dictionaryKey={el}
                        value={data?.[el] ?? ''}
                        data={data}
                        dataSchema={componentSchema}
                        name={name}
                        setDictKeys={setDictKeys}
                        actionAddDictValue={actionAddDictValue}
                    />
                ))}
            </tbody>
        </table>
    )
}
